import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { CoreData } from 'src/app/tools/core-data';
import { LoadingTask } from 'src/app/tools/loading-task';
import { NotificationManager } from 'src/app/tools/notification-manager';
import { environment } from 'src/environments/environment';
const { version: appVersion } = require('../../../../package.json');

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.scss']
})
export class NavMenuComponent implements OnInit {
    AppVersion: string;
    isExpanded = false;
    Opacity = 0;
    @ViewChild('toto', { read: ElementRef }) toggler: ElementRef;
    AppName = environment.appName;

    IsCollapseSubject: Subject<boolean> = new Subject<boolean>;

    get EurofinsIconPath() {
        return this.CoreData.IsMobile ? 'favicon.ico' : 'assets/eurofins-logo-white.png';
    }

    get PageName() {
        return this.CoreData.CurrentPageName;
    }

    constructor(
        public CoreData: CoreData,
        public loadingTask: LoadingTask,
        public coreData: CoreData,
        private snackBar: MatSnackBar) {
        this.AppVersion = appVersion;
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.isMenuTogglerDisplayed();
    }

    checkIfWeAreInTheSubMenu() {
        return this.coreData.IsInverventionSelected
    }

    ngOnInit() {
        this.coreData.IsInverventionSelected = false;

        this.loadingTask.LoadingEmitter.subscribe(x => {
            if (x) {
                this.Opacity = 100;
            } else {
                this.Opacity = 0;
            }
        });
        this.IsCollapseSubject.subscribe( x => {
            this.collapse()
        })
    }

    isLoggedIn() {
        return this.coreData.User;
    }

    collapse() {
        this.isExpanded = false;
    }

    toggle() {
        this.isExpanded = !this.isExpanded;
    }

    isMenuTogglerDisplayed() {

        return this.toggler && window.getComputedStyle(this.toggler.nativeElement).display !== 'none';
    }

    showVersion() {
        NotificationManager.handleSuccess(
            `Version: ${this.AppVersion} - Quota: ${this.coreData.getTotalPercentageAmountOfLocalStorage()}%`, this.snackBar);
    }
}
